var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m6.77,20.18h3.64c0,1-.82,1.82-1.82,1.82s-1.82-.82-1.82-1.82Zm-1.82-1.82c0,.5.41.91.91.91h5.45c.5,0,.91-.41.91-.91s-.41-.91-.91-.91h-5.45c-.5,0-.91.41-.91.91Zm10.45-7.73c0,3.47-2.42,5.33-3.43,5.91h-6.78c-1.01-.58-3.43-2.44-3.43-5.91,0-3.76,3.05-6.82,6.82-6.82s6.82,3.05,6.82,6.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.37,5.09h-2.31v2.31c0,.25-.21.46-.46.46s-.46-.21-.46-.46v-2.31h-2.31c-.25,0-.46-.21-.46-.46s.21-.46.46-.46h2.31V1.85c0-.25.21-.46.46-.46s.46.21.46.46v2.31h2.31c.25,0,.46.21.46.46s-.21.46-.46.46Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextAnswer);
export default __webpack_public_path__ + "static/media/next_answer.d9fa859f12c952fa269ee81ddb27df28.svg";
export { ForwardRef as ReactComponent };